export class FunctionalAnalysisTabs {
  public static FUNCTIONS_PERFORMED = { name: 'transaction.functions_performed', id: 1 };
  public static RISKS_ASSUMED = { name: 'transaction.risks_assumed', id: 2 };
  public static ASSETS_PROVIDED = { name: 'transaction.assets_provided', id: 3 };
}
